/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeOnboardingDetails
 */
export interface ChallengeOnboardingDetails {
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboardingDetails
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboardingDetails
     */
    description: string;
}

export function ChallengeOnboardingDetailsFromJSON(json: any): ChallengeOnboardingDetails {
    return ChallengeOnboardingDetailsFromJSONTyped(json, false);
}

export function ChallengeOnboardingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeOnboardingDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
    };
}

export function ChallengeOnboardingDetailsToJSON(value?: ChallengeOnboardingDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
    };
}


